export default function CounselorHero() {
  return (
    <section className="pt-32 pb-20 bg-[#f0f9f9]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden w-full h-[480px] md:h-[560px]">
              <img
                src="/images/counselor-portrait.png"
                alt="Robert Holmes, LCSW"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Credential Badge */}
            <div className="absolute -bottom-5 left-6 bg-white rounded-xl px-5 py-4 border border-[#c8e8e6]">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#e6f6f5]">
                  <i className="ri-award-line text-[#4db8b1] text-lg"></i>
                </div>
                <div>
                  <p className="text-[#2d2d2d] text-xs font-semibold">Licensed Clinical Social Worker</p>
                  <p className="text-[#9a9a9a] text-xs">LCSW — Licensed in MA, NC & IA</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="text-[#418b86] text-xs font-medium tracking-widest uppercase mb-4">Meet Your Counselor</p>
            <h1 className="text-3xl md:text-5xl font-light text-[#2d2d2d] leading-tight mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Robert Holmes
            </h1>
            <p className="text-[#4db8b1] text-base mb-6">LCSW — Licensed Clinical Social Worker</p>

            <p className="text-[#5a5a5a] text-base leading-relaxed mb-5">
              I am a fully licensed clinical social worker with nearly 10 years of experience in the field, currently licensed in two states. I am licensed in Massachusetts, North Carolina, and Iowa. My experience spans from therapeutic mentoring and supervising other LCSWs to one-on-one work with individuals as a therapist and clinician.
            </p>
            <p className="text-[#5a5a5a] text-base leading-relaxed mb-5">
              My approach is strength-based and person-centered. I work with ages 6 and up, with a particular focus on adolescents, teens, and adults. I believe the client should be in charge of the sessions, the goals, and the direction therapy takes them.
            </p>
            <p className="text-[#5a5a5a] text-base leading-relaxed mb-8">
              Starting anything can be daunting — I am here to assist you in feeling more confident and comfortable with the process. Together, we can identify obtainable goals and work toward them in a comfortable and accepting environment.
            </p>

            {/* Credentials */}
            <div className="flex flex-wrap gap-3">
              {[
                "Licensed Clinical Social Worker",
                "Licensed in MA, NC & IA",
                "Nearly 10 Years Experience",
                "CBT Certified",
                "Mindfulness-Based",
                "Ages 6 & Up",
              ].map((cred) => (
                <span key={cred} className="bg-white border border-[#c8e8e6] text-[#418b86] text-xs px-3 py-1.5 rounded-full">
                  {cred}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
